import { useTranslation } from "react-i18next";
import { HTMLInputTypeAttribute, InputHTMLAttributes } from "react";
import {
  Controller,
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";

interface InputTextProps<FieldsType extends FieldValues> {
  type?: HTMLInputTypeAttribute;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  rules?: RegisterOptions<FieldsType>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  label?: string;
  required?: boolean;
  shouldUnregister?: boolean;
  placeholder?: string;
  requiredMessage?: string;
  options: string[];
}

export default function RadioInput<FieldsType extends FieldValues>({
  placeholder,
  type,
  label,
  name,
  control,
  required,
  shouldUnregister,
  requiredMessage,
  rules,
  inputProps,
  options,
}: InputTextProps<FieldsType>) {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: requiredMessage || (required && "Required"),
        ...(rules || {}),
      }}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className="relative ml-1">
            {label && (
              <label className="text-base  mb-0.5 block" htmlFor={field?.name}>
                <span>
                  {t(label)}
                  {(required || requiredMessage) && (
                    <span className="text-red-600 ml-0.5 text-base">*</span>
                  )}
                </span>
              </label>
            )}
            <div className="flex items-center">
              {options.map((label) => (
                <div key={label} className="flex items-center gap-3 w-[100px]">
                  <input
                    id={field.name + label}
                    checked={field.value === label}
                    {...field}
                    value={label}
                    type="radio"
                  />
                  <label htmlFor={field.name + label}>{t(label)}</label>
                </div>
              ))}
            </div>
            {error?.message && (
              <p className="text-red-600 font-normal text-sm m-0 p-0 bottom-0 left-0 right-0">
                {t(error?.message)}
              </p>
            )}
          </div>
        );
      }}
    />
  );
}
